import Vue from 'vue'
import vueApp from './main'
import store from './store'
import router from './router'


const beforeCreate = () => {
  store.dispatch('user/restoreCurrentUser')
  store.dispatch('tenant/restoreCurrentTenant')
}


// this handler is called when the user is back from auth0
const authCallback = async (appState) => {
  Vue.prototype.$redirectingFromAuth = true

  let redirectLocation = appState && appState.targetUrl
    ? appState.targetUrl
    : window.location.pathname

  try {
    const tenants = await store.dispatch('tenant/loadTenants')
    if (!tenants.length) {
      redirectLocation = { name: 'unauthorized' }
    } else {
      store.dispatch('tenant/setCurrentTenant')
      await store.dispatch('settings/loadSettings')
      await store.dispatch('user/loadCurrentUser')
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      redirectLocation = { name: 'unauthorized' }
    } else {
      redirectLocation = { name: 'error' }
      vueApp.$log.error(error)
    }
  }

  router.push(redirectLocation,
    () => {
      Vue.prototype.$redirectingFromAuth = false
    }
  )
}


// this handler is called when auth0 has finished initialization
const authLoaded = async () => {
  if (!vueApp.$auth.isAuthenticated || vueApp.$auth.redirected) return

  try {
    const tenants = await store.dispatch('tenant/loadTenants')
    if (!tenants.length) {
      router.push({ name: 'unauthorized' })
    } else {
      if (!store.state.tenant.current || !tenants.find(x => x.name === store.state.tenant.current)) {
        store.dispatch('tenant/setCurrentTenant')
      }
      await store.dispatch('user/loadCurrentUser')
      await store.dispatch('settings/loadSettings')
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      router.push({ name: 'unauthorized' })
    } else {
      vueApp.$log.error(error)
      router.push({ name: 'error' })
    }
  }
}


export default {
  authCallback,
  authLoaded,
  beforeCreate
}
